import { type ComponentProps, memo } from 'react';

import { ClipType } from '@air/api/types';
import { FileIcon, ImageIcon, MusicIcon, VideoIcon } from '@air/design-icons';

/** Exhaustive so a new `ClipType` is a compile error. */
const ASSET_TYPE_ICONS: Record<ClipType, typeof ImageIcon> = {
  [ClipType.animated]: ImageIcon,
  [ClipType.audio]: MusicIcon,
  [ClipType.livePhoto]: ImageIcon,
  [ClipType.nonMedia]: FileIcon,
  [ClipType.photo]: ImageIcon,
  [ClipType.video]: VideoIcon,
};

export type WorkspaceAgentAssetTypeIconProps = {
  className?: string;
  size?: ComponentProps<typeof ImageIcon>['size'];
  type: ClipType;
};

export const WorkspaceAgentAssetTypeIcon = memo(({ className, size, type }: WorkspaceAgentAssetTypeIconProps) => {
  const Icon = ASSET_TYPE_ICONS[type];

  return <Icon aria-hidden className={className} size={size} />;
});

WorkspaceAgentAssetTypeIcon.displayName = 'WorkspaceAgentAssetTypeIcon';
